import { QuoteTransaction } from 'src/redux/types/quoteSlice';
import { formatPrice } from 'src/utils/transaction/summary';

export const getQuoteTransactionLabel = (transaction: QuoteTransaction) =>
	`${transaction.type === 'Buy' ? 'Purchase' : 'Sale'} of ${formatPrice(
		transaction.price,
		false,
		false,
	)} ${transaction.tenure.toUpperCase()}`.toUpperCase();
